module.exports = __webpack_public_path__ + "img/icon_zoom.c3b481e0.svg";